import { Component, Input, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { SelectedSessionDate } from "../../../../_models/student-bookings/selected-session-date.model";
import { DynamicConfirmModalComponent } from "../../../../shared/dynamic-confirm-modal/dynamic-confirm-modal.component";
import { BaseLearningSectionComponent } from '../../../../shared/learning-section/base-learning-section/base-learning-section.component';
import { LearningSectionFlowControlHelperService } from "../../../../_helpers/learning-section-flow-control-helper/learning-section-flow-control-helper.service";
import { SessionSection } from "../../../../_models/timeline-models/section-models/session-section.model";
import { FeatureHelperService } from "../../../../_helpers/feature-helper/feature-helper.service";

@Component({
    selector: 'session-section',
    templateUrl: './session-section.component.html',
    styleUrls: ['./session-section.component.css'],
    standalone: false
})
export class SessionSectionComponent extends BaseLearningSectionComponent implements OnInit {

  @Input() timelineSection: SessionSection = new SessionSection();
  editMode = false;
  public hasData = false;
  public metricsVisible: boolean = false;

  constructor(public flowHelperService: LearningSectionFlowControlHelperService,
    public dialog: MatDialog,
    public router: Router,
    public featureHelperService: FeatureHelperService) {
    super(flowHelperService, dialog);
    this.sectionTitle = 'Session';
  }

  ngOnInit(): void {
    this.hasData = this.timelineSection.comprehension != null && this.timelineSection.comprehension != 0
      && this.timelineSection.engagement != null && this.timelineSection.engagement != 0;
    this.metricsVisible = !this.featureHelperService.hasFeature('Student');
  }

  public openSection(component: any): any {
    const dialogRef = this.dialog.open(DynamicConfirmModalComponent, {
      data: { confirmMessage: 'You are about to move away from the timeline to session ' + this.timelineSection.sectionDate + ' are you sure?' },
      panelClass: 'my-confirm-dialog'
    });
    dialogRef.afterClosed().subscribe((confirm: boolean) => {
      if (confirm) {
        this.router.navigate(['/add-session'], {
          state: { 
           placementId: this.placementId, 
           selectedSessionDate: new SelectedSessionDate(this.timelineSection.sectionDate, this.timelineSection.startTime, this.timelineSection.endTime), 
           componentViewMode: 'View'
         }, queryParams: { returnUrl: window.location.pathname } });
      }
    });
  }
}
